'use client'

import { useEffect } from 'react'

import { useFetch } from '@marketplace-web/core-api/api-client-util'
import { TransactionSide } from '@marketplace-web/messaging/conversation-messaging-data'
import {
  getSellerOfferOptions,
  transformSellerOfferOptionsResponse,
} from '@marketplace-web/offers/price-offers-data'

type Props = {
  userSide?: TransactionSide | null
  transactionId?: number
}

const useGetSellerOfferOptions = ({ userSide, transactionId }: Props) => {
  const { fetch: fetchSellerOfferOptions, transformedData: sellerOfferOptions } = useFetch(
    getSellerOfferOptions,
    transformSellerOfferOptionsResponse,
  )

  const isSeller = userSide === TransactionSide.Seller

  useEffect(() => {
    if (!isSeller || !transactionId) return

    fetchSellerOfferOptions({ transactionId })
  }, [fetchSellerOfferOptions, isSeller, transactionId])

  return {
    sellerOfferOptions,
  }
}

export default useGetSellerOfferOptions
